import * as actionTypes from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const listReducer = (state = initialState.partnerLogs.list, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PARTNER_LOGS_STARTED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: true, loaded: false };
      return result;
    }

    case actionTypes.LOAD_PARTNER_LOGS_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;
      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false, loaded: true };
      return result;
    }

    case actionTypes.LOAD_PARTNER_LOGS_FAILED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: false, loaded: false };
      return result;
    }

    case actionTypes.PARTNER_LOG_LIST_INVALIDATED: {
      return initialState.partnerLogs;
    }

    default:
      return state;
  }
};

const itemReducer = (state = initialState.partners.items, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PARTNER_LOG_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }
    case actionTypes.LOAD_PARTNER_LOG_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true };
      return result;
    }

    case actionTypes.LOAD_PARTNER_LOG_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};

const reducer = combineReducers({
  list: listReducer,
  items: itemReducer
});

export default reducer;
